export const getMesCommandesOrders = state => state.mesCommandes.orders;
export const getMesTicketsOrders = state => state.mesCommandes.tickets;
export const getError = state => state.mesCommandes.error;
export const getStatus = state => state.mesCommandes.status;
export const getLoading = state => state.mesCommandes.loading;